import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction, refreshBoards } from '../../actions';
import {
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  TASK_STATUS_ACTIVE,
  TASK_STATUS_INACTIVE,
  TASK_STATUS_PLAN,
} from '../../constants';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import { List, Row, Cell } from '../../../../components/List';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';

import { Cell as ActionCell } from '../Cell';
import { formatCurrency } from '../../../../utils/string';
import { updateInvoiceStatus } from '../../../Invoices/actions';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const Container = styled.div`
  .pane {
    padding: 24px 12px;

    .fields {
      margin-top: 24px;
    }

    h3 {
      margin-bottom: 12px;
    }

    h4 {
      margin-top: 24px;
      font-size: 20px;
    }
  }
`;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class betaalstatus_controlerenComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  render01(name) {
    return (
      <Checkbox
        key={name}
        checked={this.state[name] == TASK_STATUS_ACTIVE}
        onChange={() => {
          this.setState({ [name]: this.state[name] != TASK_STATUS_ACTIVE ? TASK_STATUS_ACTIVE : TASK_STATUS_INACTIVE });
        }}
      >
        {this.lbl(`vehicle.property.${name}`)}
      </Checkbox>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        {this.renderModalBody()}
      </Modal>
    );
  }

  renderModalBody() {
    if (this.state.loading) return <Loader />;
    return (
      <WithVehicle vehicle_id={this.vehicle.id} loader>
        <VehicleHeader vehicle={this.vehicle} />
        <div className="pane">
          
        </div>
        {this.vehicle ? (
          <VBox center>
             <Row>
                    <Cell>{this.lbl(`vehicle.property.invoice_outgoing_company_id`)}</Cell>
                    <Cell>
                      <CompanyLabelById company_id={this.vehicle.invoice_outgoing_company_id} />
                    </Cell>
                  </Row>
                  

              <Row>
            <Button onClick={this.tofn(`/companies/${this.vehicle.invoice_outgoing_company_id}`)}>
              <View /> {this.lbl('vehicle.details.supplier.company.opencompany')}
            </Button>
            
              </Row>
              
              
              
             

          </VBox>
        ) : null}

<ModalControls>
            <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
            <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
          </ModalControls>
      </WithVehicle>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <VehicleStatusLabel color={
                vehicle?.outgoing_invoice_payment_status === 'PAID' ? '#15AC79' :
                vehicle?.outgoing_invoice_payment_status === 'PARTLY_PAID' ? 'black' :
                'red'
              }>
             
            {vehicle?.outgoing_invoice_payment_status === 'PAID' ? 'Betaald' :
                vehicle?.outgoing_invoice_payment_status === 'PARTLY_PAID' ? 'Gedeeltelijk betaald' :
                'Niet betaald'}  
            </VehicleStatusLabel>
            <br />
            
            <VehicleStatusLabel color={
                vehicle?.company_debitor_status === '1' ? '#15AC79' : 'red'
              }>
            {vehicle?.company_debitor_status === '1' ? 'Relatie goedgekeurd' : 'Relatie niet goedgekeurd' }
            </VehicleStatusLabel>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }
}

betaalstatus_controlerenComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    invoicePaid(invoiceId, callback) {
      dispatch(updateInvoiceStatus(invoiceId, 2, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const betaalstatus_controleren = compose(
  withConnect,
  withRouter,
)(betaalstatus_controlerenComp);
